import React from "react";
import { useNavigate } from "react-router-dom";
import { images, buttonConfig } from "./thankYouImageData";
import { HomeIcon } from "@assets/svgIcons";

import "./index.scss";

const ThankYouImage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className="thankyou-container">
      {/* Company logo at the top */}
      <div className="thankyou-logo-wrapper">
        <img
          src={images.logo.src}
          alt={images.logo.alt}
          className="thankyou-logo"
        />
      </div>

      {/* Thank you image below logo */}
      <div className="thankyou-image-wrapper">
        <img
          src={images.thankYou.src}
          alt={images.thankYou.alt}
          className="thankyou-image"
        />
      </div>

      {/* Go to Home button */}
      <button
        onClick={handleGoHome}
        className="thankyou-home-button"
        tabIndex={0}
      >
        <HomeIcon size={buttonConfig.iconSize} />

        <span className="thankyou-button-text">{buttonConfig.text}</span>
        <span className="thankyou-button-shimmer"></span>
      </button>
    </div>
  );
};

export default ThankYouImage;
